<div class="card" *ngIf="id_personalizable_enabled && showAdvOpts">
  <div class="card-header card-header-primary">
    <h4 class="card-title">{{ 'texto_760' | translate }}</h4>
  </div>
  <div class="content">
    <form [formGroup]="validatingForm" style="margin-left: 25px; margin-right: 25px;">
      
      <!-- Reset numbering Section -->
      <div class="row" style="padding-top: 1rem">
        <div class="col-md-6">
          <div class="form-group">
            <mat-checkbox [(ngModel)]="reset_numberingF" formControlName="reset_numbering"class="example-margin"
            (change)="disableChecks()">
              {{'texto_766' |translate }}
            </mat-checkbox>
          </div>
        </div>
      </div>

      <!-- Suboptions for Reset Numbering - Nested Group -->
      <div *ngIf="reset_numberingF" class="reset-numbering-suboptions">
        
        <!-- Custom Reset Date Section - Conditional -->
        <div class="row suboption-row">
          <div class="col-md-6">
            <div class="form-group">
              <mat-checkbox [(ngModel)]="custom_reset_dateF" formControlName="custom_reset_date" class="example-margin"
                (change)="toggleCustomDateInput()">
                {{'texto_957' | translate }}
              </mat-checkbox>
              <div class="reset-helper">
                <span class="reset-helper-icon">ℹ</span>
                <span>
                  {{ 'texto_958' | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Custom Reset Date Input - Conditional (nested deeper) -->
        <div *ngIf="custom_reset_dateF" class="custom-date-input-container">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <input [(ngModel)]="custom_reset_date_valueF" formControlName="custom_reset_date_value" type="date"
                  class="form-control" [min]="minDate" (change)="syncIdentifierYearFromCustomResetDate()">

                <!-- Error Message for future date validation -->
                <mdb-error id="custom-date-error" role="alert" *ngIf="validatingForm.get('custom_reset_date_value')?.invalid && 
                      (validatingForm.get('custom_reset_date_value')?.dirty || 
                      validatingForm.get('custom_reset_date_value')?.touched)">
                  {{ 'texto_914' | translate }}
                </mdb-error>

                <!-- Success Message -->
                <mdb-success style="font-size: 0.7rem !important; margin-left: 0% !important;"
                  *ngIf="validatingForm.get('custom_reset_date_value')?.valid">
                  {{ 'texto_62' | translate }}
                </mdb-success>
              </div>
            </div>
          </div>
        </div>

      </div>
      <!-- reset numbering Year Section -->
      
      <!-- Characters Section -->
      <div class="row suboptioncharacter-row">
        <div class="col-md-6">
          <div class="form-group">
            <mat-checkbox [(ngModel)]="include_charactersF" formControlName="include_characters" 
              (change)="toggleInput('include_characters', include_charactersF, 'identifier_characters')"
              class="example-margin">{{ 'texto_761' | translate }}</mat-checkbox>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input [(ngModel)]="identifier_charactersF" formControlName="identifier_characters" type="text"
              class="form-control" 
              (input)="updateIdentifier()" pattern="[A-za-z]*" maxlength="7">

            <!-- Error Message -->
            <mdb-error id="identifier-characters-error" role="alert" *ngIf="validatingForm.get('identifier_characters')?.invalid && 
                  (validatingForm.get('identifier_characters')?.dirty || 
                  validatingForm.get('identifier_characters')?.touched)">
              {{ 'texto_61' | translate }}
            </mdb-error>

            <!-- Success Message -->
            <mdb-success style="font-size: 0.7rem !important; margin-left: 0% !important;"
              *ngIf="validatingForm.get('identifier_characters')?.valid">
              {{ 'texto_62' | translate }}
            </mdb-success>
          </div>
        </div>
      </div>
      <!-- End Characters Section -->

      <!-- Year Section -->
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <mat-checkbox [(ngModel)]="include_yearF" formControlName="include_year" 
              (change)="toggleInput('include_year', include_yearF, 'identifier_year')" class="example-margin">{{
              'texto_762' |
              translate }}</mat-checkbox>
            <div class="reset-helper">
              <span class="reset-helper-icon">ℹ</span>
              <span>
                Si la fecha personalizada está activa, el año se muestra como ciclo (26-27). Si no, se muestra el año actual.
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <input [value]="include_yearF ? identifier_yearF : ''" formControlName="identifier_year" type="text"
              class="form-control" readonly />
          </div>
        </div>
      </div>
      <!-- End Year Section -->

      <!-- Generated Identifier Section -->
      <div class="row" style="padding-bottom: 1rem;">
        <div class="col-md-12">
          <label class="bmd-label-floating identifier-preview">{{ 'texto_764' | translate }}{{ idPersonalizable.personalized_identifier }}</label>
        </div>
      </div>
      <!-- Submit Button -->
      <button [disabled]="validatingForm.invalid && checkResetDisabled" (click)="submitIdentifier()" type="submit"
        class="btn btn-primary pull-right">
        {{ 'texto_384' | translate }}
      </button>
      <div class="clearfix"></div>
    </form>
  </div>
</div>